import { useState, useEffect, useRef } from "react";
import { Image } from "./image";

// Import specific images for the pendant slider
import PendantImage1 from "../data/img/pendantImages/‏bitcoinPendant.png";
import PendantImage2 from "../data/img/pendantImages/originPedant.png";

// Import September images
import IMG_0212 from "../data/img/positions/2024/September/IMG_0212.PNG";
import IMG_0213 from "../data/img/positions/2024/September/IMG_0213.PNG";
import IMG_0214 from "../data/img/positions/2024/September/IMG_0214.PNG";
import IMG_0215 from "../data/img/positions/2024/September/IMG_0215.PNG";
import IMG_0216 from "../data/img/positions/2024/September/IMG_0216.PNG";
import IMG_0217 from "../data/img/positions/2024/September/IMG_0217.PNG";
import IMG_0218 from "../data/img/positions/2024/September/IMG_0218.PNG";
import IMG_0219 from "../data/img/positions/2024/September/IMG_0219.PNG";
import IMG_0220 from "../data/img/positions/2024/September/IMG_0220.PNG";
import IMG_0221 from "../data/img/positions/2024/September/IMG_0221.PNG";
import IMG_0222 from "../data/img/positions/2024/September/IMG_0222.PNG";

// Import October images
import IMG_0123 from "../data/img/positions/2024/October/IMG_0123.PNG";
import IMG_0124 from "../data/img/positions/2024/October/IMG_0124.PNG";
import IMG_0125 from "../data/img/positions/2024/October/IMG_0125.PNG";
import IMG_0126 from "../data/img/positions/2024/October/IMG_0126.PNG";
import IMG_0127 from "../data/img/positions/2024/October/IMG_0127.PNG";
import IMG_0128 from "../data/img/positions/2024/October/IMG_0128.PNG";
import IMG_0129 from "../data/img/positions/2024/October/IMG_0129.PNG";
import IMG_0130 from "../data/img/positions/2024/October/IMG_0130.PNG";
import IMG_0131 from "../data/img/positions/2024/October/IMG_0131.PNG";
import IMG_0132 from "../data/img/positions/2024/October/IMG_0132.PNG";
import IMG_0133 from "../data/img/positions/2024/October/IMG_0133.PNG";
import IMG_0134 from "../data/img/positions/2024/October/IMG_0134.PNG";
import IMG_0135 from "../data/img/positions/2024/October/IMG_0135.PNG";
import IMG_0136 from "../data/img/positions/2024/October/IMG_0136.PNG";
import IMG_0137 from "../data/img/positions/2024/October/IMG_0137.PNG";
import IMG_0138 from "../data/img/positions/2024/October/IMG_0138.PNG";
import IMG_0139 from "../data/img/positions/2024/October/IMG_0139.PNG";
import IMG_0140 from "../data/img/positions/2024/October/IMG_0140.PNG";

// Import November images
import IMG_0116 from "../data/img/positions/2024/November/IMG_0116.PNG";
import IMG_0117 from "../data/img/positions/2024/November/IMG_0117.PNG";
import IMG_0118 from "../data/img/positions/2024/November/IMG_0118.PNG";
import IMG_0119 from "../data/img/positions/2024/November/IMG_0119.PNG";
import IMG_0120 from "../data/img/positions/2024/November/IMG_0120.PNG";
import IMG_0121 from "../data/img/positions/2024/November/IMG_0121.PNG";
import IMG_0122 from "../data/img/positions/2024/November/IMG_0122.PNG";

const images = {
  2024: {
    September: [
      IMG_0212,
      IMG_0213,
      IMG_0214,
      IMG_0215,
      IMG_0216,
      IMG_0217,
      IMG_0218,
      IMG_0219,
      IMG_0220,
      IMG_0221,
      IMG_0222,
    ],
    October: [
      IMG_0123,
      IMG_0124,
      IMG_0125,
      IMG_0126,
      IMG_0127,
      IMG_0128,
      IMG_0129,
      IMG_0130,
      IMG_0131,
      IMG_0132,
      IMG_0133,
      IMG_0134,
      IMG_0135,
      IMG_0136,
      IMG_0137,
      IMG_0138,
      IMG_0139,
      IMG_0140,
    ],
    November: [
      IMG_0116,
      IMG_0117,
      IMG_0118,
      IMG_0119,
      IMG_0120,
      IMG_0121,
      IMG_0122,
    ],
  },
  2025: {},
  2026: {},
};

// Define pendant images in a separate array
const pendantImages = [
  {
    src: PendantImage1,
    title: "Model",
    description: "Bitcoin Pendant"
  },
  {
    src: PendantImage2,
    title: "Type",
    description: "Exquisite craftsmanship for an elegant look."
  },
];

export const Gallery = (props) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [accessGranted, setAccessGranted] = useState(false);
  const [btcPrice, setBtcPrice] = useState(null);
  const [priceDirection, setPriceDirection] = useState(null);
  const [flash, setFlash] = useState(false);
  const lastPriceRef = useRef(null);

  useEffect(() => {
    const fetchBTC = async () => {
      try {
        const res = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd"
        );
        const data = await res.json();
        const price = data.bitcoin.usd;

        if (lastPriceRef.current !== null) {
          if (price > lastPriceRef.current) {
            setPriceDirection("up");
          } else if (price < lastPriceRef.current) {
            setPriceDirection("down");
          }
        }

        if (lastPriceRef.current !== null && price !== lastPriceRef.current) {
          setFlash(true);
          setTimeout(() => setFlash(false), 600);
        }

        lastPriceRef.current = price;
        setBtcPrice(price);
      } catch (err) {
        console.error("BTC price fetch failed", err);
      }
    };

    fetchBTC();
    const interval = setInterval(fetchBTC, 15000);

    return () => clearInterval(interval);
  }, []);

  const handleYearClick = (year) => {
    if (!accessGranted) {
      const userPassword = prompt('Enter the password to view this section:');
      if (userPassword === 'DrBrokersTop') {
        setAccessGranted(true);
      } else {
        alert('Incorrect password!');
        return;
      }
    }
    setSelectedYear(year === selectedYear ? null : year);
    setSelectedMonth(null);
  };
  const handleMonthClick = (month) => {
    setSelectedMonth(month === selectedMonth ? null : month);
  };

  const handleImageClick = (imgSrc) => {
    setSelectedImage(imgSrc); // Set the clicked image as the selected image
  };

  const closeImage = () => {
    setSelectedImage(null); // Clear the selected image to hide the large view
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Comunity Pendant</h2>
          {/* Swiper Slider for Pendant Images */}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "40px",
              justifyContent: "center",
              margin: "40px 0",
            }}
          >
            {pendantImages.map((item, i) => (
              <div
                key={i}
                onClick={() => handleImageClick(item.src)}
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  padding: "25px",
                  borderRadius: "16px",
                  background: "linear-gradient(to bottom right, #000000, #2b1f19, #805A40)",
                  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.5)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 10px 25px rgba(128, 90, 64, 0.7)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 6px 18px rgba(0, 0, 0, 0.5)";
                }}
              >
                <img
                  src={item.src}
                  alt={item.title}
                  style={{
                    width: "100%",
                    maxWidth: "220px",
                    margin: "0 auto 15px",
                    borderRadius: "12px",
                    border: "2px solid black",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                    objectFit: "cover",
                  }}
                />
                <h3 style={{ color: "#ffffff", marginBottom: "8px" }}>{item.title}</h3>
                <p style={{ fontSize: "15px", color: "rgba(255,255,255,0.8)" }}>{item.description}</p>
              </div>
            ))}
          </div>

          {btcPrice && (
            <div
              style={{
                margin: "40px auto",
                maxWidth: "420px",
                padding: "24px 28px",
                borderRadius: "18px",
                background:
                  flash && priceDirection === "up"
                    ? "linear-gradient(135deg, #003b2f, #001f18)"
                    : flash && priceDirection === "down"
                      ? "linear-gradient(135deg, #3b0000, #1f0000)"
                      : "linear-gradient(135deg, #0b0b0b, #1c140f)",
                border: "1px solid rgba(247,147,26,0.35)",
                boxShadow: "0 12px 32px rgba(0,0,0,0.7)",
                textAlign: "center",
                fontFamily: "monospace",
                transition: "background 0.25s ease",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  letterSpacing: "2px",
                  color: "#f7931a",
                  marginBottom: "6px",
                }}
              >
                PENDANT PRICE
              </div>

              <div
                style={{
                  fontSize: "36px",
                  fontWeight: "700",
                  color:
                    priceDirection === "up"
                      ? "#00ff9c"
                      : priceDirection === "down"
                        ? "#ff4d4f"
                        : "#ffffff",
                  transition: "color 0.3s ease",
                }}
              >
                {priceDirection === "up" && "▲ "}
                {priceDirection === "down" && "▼ "}
                ${btcPrice.toLocaleString()}
                <span style={{ fontSize: "18px", marginLeft: "6px" }}>USD</span>
              </div>


              <div
                style={{
                  fontSize: "12px",
                  marginTop: "6px",
                  color: "rgba(255,255,255,0.55)",
                }}
              >
                Live · Updates every 15s
              </div>
            </div>
          )}
          <ol>
            <li><strong>Handmade, available in yellow or white gold.</strong></li>
            <li><strong>symbolizing success in the Dr-Brokers community.</strong></li>
            <li><strong>Material:</strong> 14k gold</li>
            <li><strong>Weight:</strong> 10 grams</li>
            <li><strong>Size:</strong>3x2 cm </li>
            <li><strong>Inlay:</strong> 2.5 carat diamonds, VS Isolated quality.</li>
            <li><strong>Finish:</strong> Glossy and precise polishing.</li>
          </ol>
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <a
              href="https://shop.ledger.com/?r=d75e06f3b125"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "15px 30px",
                background: "linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .04) 14.9%, hsla(0, 0%, 100%, .04) 85.37%, hsla(0, 0%, 100%, 0))",
                color: "#fff",
                fontSize: "18px",
                fontWeight: "bold",
                textDecoration: "none",
                borderRadius: "12px",
                boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.3)";
              }}
            >
              Buy LEDGER Products
            </a>
          </div>
          <h2>Tools</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))
              : "Loading..."}
          </div>
          <div className="gallery">
            <div className="section-title">
              <h2>Positions</h2>
            </div>
            {Object.keys(images).map((year) => (
              <div key={year}>
                <h3
                  onClick={() => handleYearClick(year)}
                  style={{ cursor: "pointer" }}
                >
                  {year}
                </h3>
                {selectedYear === year && (
                  <div className="months">
                    {Object.keys(images[year]).map((month) => (
                      <div key={month}>
                        <h4
                          onClick={() => handleMonthClick(month)}
                          style={{ cursor: "pointer", paddingLeft: "20px" }}
                        >
                          {month}
                        </h4>
                        {selectedMonth === month && (
                          <div className="images" style={{ paddingLeft: "40px" }}>
                            {images[year][month].map((imgSrc, index) => (
                              <img
                                key={index}
                                src={imgSrc}
                                alt={`${month} ${index}`}
                                style={{ width: "100px", margin: "10px", cursor: "pointer" }}
                                onClick={() => handleImageClick(imgSrc)}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* Full-size Image Overlay */}
            {selectedImage && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
                onClick={closeImage}
              >
                <img
                  src={selectedImage}
                  alt="Enlarged view"
                  style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
                />
                <button
                  onClick={closeImage}
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    fontSize: "24px",
                    background: "none",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};